import { useLocation, Navigate } from "react-router-dom";

interface LegacyPrefixRedirectProps {
  fromPrefix: string;
  toPrefix: string;
}

/**
 * Redirects legacy routes to their new /app/* equivalents while preserving
 * the full subpath, query string, and hash.
 * 
 * Example: /producer/farm/123/events?filter=active#section
 *       → /app/producer/farm/123/events?filter=active#section
 */
export function LegacyPrefixRedirect({ fromPrefix, toPrefix }: LegacyPrefixRedirectProps) {
  const location = useLocation();
  const { pathname, search, hash } = location;

  // Guard against redirect loops - if already at target prefix, do nothing
  if (pathname.startsWith(toPrefix)) {
    return null;
  }

  // Only redirect if the pathname starts with fromPrefix
  if (!pathname.startsWith(fromPrefix)) {
    return null;
  }

  // Remove the fromPrefix and build the new path
  const remainingPath = pathname.slice(fromPrefix.length);
  const newPath = `${toPrefix}${remainingPath}${search}${hash}`;

  return <Navigate to={newPath} replace />;
}
